import styled from "styled-components";

export const PickerMultiBoxDetailsWrapper = styled.div`
  max-width: 430px;
  margin: auto;
  .qtyWrapper {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 15px;
  }

  .medName {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  .qty-value {
    font-weight: 500;
  }

  .ctaWrapper {
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }

  .quantityPickerCTA {
    width: 100%;
  }

  .quantity-textfield {
    width: 100%;
  }

  .quantityPickerCTA button {
    width: 100%;
    background: #0071bc;
    color: #fff;
    height: 44px;
    border-radius: 4px;
    font-size: 15px;
    font-weight: 600;
  }

  .quantity-textfield .ant-input-number {
    width: 100%;
  }
  .quantity-textfield input {
    width: 100%;
    height: 44px;
    font-size: 14px;
  }
  .boxWrapper {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .boxValue {
    font-weight: 600;
    margin-left: 5px;
    font-size: 16px;
    color: #0071bc;
  }
`;
